import { render, staticRenderFns } from "./orderVideoSend.vue?vue&type=template&id=6657c00f&scoped=true"
import script from "./orderVideoSend.vue?vue&type=script&lang=js"
export * from "./orderVideoSend.vue?vue&type=script&lang=js"
import style0 from "./orderVideoSend.vue?vue&type=style&index=0&id=6657c00f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6657c00f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/linyuqiu/IdeaProjects/huoquan/ningde-huoquan-supplier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6657c00f')) {
      api.createRecord('6657c00f', component.options)
    } else {
      api.reload('6657c00f', component.options)
    }
    module.hot.accept("./orderVideoSend.vue?vue&type=template&id=6657c00f&scoped=true", function () {
      api.rerender('6657c00f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplier/order/orderVideoSend.vue"
export default component.exports